import { render } from "./SVGClose.vue?vue&type=template&id=338595a6&ts=true"
import script from "./SVGClose.vue?vue&type=script&lang=ts"
export * from "./SVGClose.vue?vue&type=script&lang=ts"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__